// @flow
import React from "react";

type ProjectCloseStatusLabelPropsType = {
  outcome: boolean | null,
  labelClass?: string
};

const ProjectCloseStatusLabel = (props: ProjectCloseStatusLabelPropsType): React$Element<*> => {
  const outcome = props.outcome;
  const labelClass = props.labelClass;
 
  if (outcome === true) {
    return (
      <span className={"green-label" + (labelClass ? " " + labelClass : "")}>Win</span>
    );
  }
  else if (outcome === false){
    return (
      <span className={"red-label" + (labelClass ? " " + labelClass : "")}>Lost</span>
    );
  }
  else {
    return (
      <span></span>
    );
  }
};

export default ProjectCloseStatusLabel;